import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <h3 className="text-2xl font-bold text-purple-500">Mukesh Rathore</h3>
            </div>
             <p className="text-gray-400 mb-1">
              Original Artist Builder
            </p>
            <p className="text-gray-400 mb-2">
              India's #1 Indie Music Coach
            </p>
            <p className="text-gray-500 text-sm leading-relaxed">
              Helping aspiring singers become original artists — step by step in 90 days.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="/about" className="text-gray-400 hover:text-purple-500 transition-colors">
                  About
                </a>
              </li>
              <li>
                <a href="/blog" className="text-gray-400 hover:text-purple-500 transition-colors">
                  Blog
                </a>
              </li>
              <li>
                <a href="/music" className="text-gray-400 hover:text-purple-500 transition-colors">
                  Music
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Resources</h4>
            <ul className="space-y-2">
              <li>
                <a href="/tutorial" className="text-gray-400 hover:text-purple-500 transition-colors">
                  Free Training
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-purple-500 transition-colors">
                  Success Stories
                </a>
              </li>
              <li>
                <a href="/#faq" className="text-gray-400 hover:text-purple-500 transition-colors">
                  FAQs
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Connect With Us</h4>
            <div className="flex space-x-4 mb-4">
              <a href="https://www.facebook.com/mratz.co" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-purple-500 text-2xl transition-colors">
                <span>📘</span>
              </a>
              <a href="https://x.com/mukemusic" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-purple-500 text-2xl transition-colors">
                <span>🐦</span>
              </a>
              <a href="https://www.instagram.com/mratz.co" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-purple-500 text-2xl transition-colors">
                <span>📷</span>
              </a>
              <a href="#" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-purple-500 text-2xl transition-colors">
                <span>💼</span>
              </a>
            </div>
            <p className="text-gray-400">
              <a href="mailto:connect@indiemusiccreators.com" className="hover:text-purple-500 transition-colors">
                connect@indiemusiccreators.com
              </a>
            </p>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-400">
            &copy; {new Date().getFullYear()} Mukesh Rathore. All rights reserved.
          </p>
          <div className="mt-2 space-x-4">
            <a href="#" className="text-gray-400 hover:text-purple-500 text-sm transition-colors">
              Privacy Policy
            </a>
            <span className="text-gray-600">•</span>
            <a href="#" className="text-gray-400 hover:text-purple-500 text-sm transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
